/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CampaignControllerDtoAppDetailAppDetailDataList from './CampaignControllerDtoAppDetailAppDetailDataList';
import MaterialProperty from './MaterialProperty';

/**
 * The CampaignControllerDtoAppDetailResponse model module.
 * @module model/CampaignControllerDtoAppDetailResponse
 * @version 1.0
 */
class CampaignControllerDtoAppDetailResponse {
    /**
     * Constructs a new <code>CampaignControllerDtoAppDetailResponse</code>.
     * @alias module:model/CampaignControllerDtoAppDetailResponse
     */
    constructor() { 
        
        CampaignControllerDtoAppDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CampaignControllerDtoAppDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoAppDetailResponse} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoAppDetailResponse} The populated <code>CampaignControllerDtoAppDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoAppDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('appNo')) {
                obj['appNo'] = ApiClient.convertToType(data['appNo'], 'Number');
            }
            if (data.hasOwnProperty('category')) {
                obj['category'] = ApiClient.convertToType(data['category'], 'Number');
            }
            if (data.hasOwnProperty('packageName')) {
                obj['packageName'] = ApiClient.convertToType(data['packageName'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('developer')) {
                obj['developer'] = ApiClient.convertToType(data['developer'], 'String');
            }
            if (data.hasOwnProperty('profileImage')) {
                obj['profileImage'] = ApiClient.convertToType(data['profileImage'], 'String');
            }
            if (data.hasOwnProperty('logoImage')) {
                obj['logoImage'] = ApiClient.convertToType(data['logoImage'], 'String');
            }
            if (data.hasOwnProperty('appDesc')) {
                obj['appDesc'] = ApiClient.convertToType(data['appDesc'], 'String');
            }
            if (data.hasOwnProperty('distributionChannel')) {
                obj['distributionChannel'] = ApiClient.convertToType(data['distributionChannel'], 'Number');
            }
            if (data.hasOwnProperty('appUrl')) {
                obj['appUrl'] = ApiClient.convertToType(data['appUrl'], 'String');
            }
            if (data.hasOwnProperty('updateAt')) {
                obj['updateAt'] = ApiClient.convertToType(data['updateAt'], 'Date');
            }
            if (data.hasOwnProperty('campaigns')) {
                obj['campaigns'] = ApiClient.convertToType(data['campaigns'], [CampaignControllerDtoAppDetailAppDetailDataList]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoAppDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoAppDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['packageName'] && !(typeof data['packageName'] === 'string' || data['packageName'] instanceof String)) {
            throw new Error("Expected the field `packageName` to be a primitive type in the JSON string but got " + data['packageName']);
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }
        // ensure the json data is a string
        if (data['developer'] && !(typeof data['developer'] === 'string' || data['developer'] instanceof String)) {
            throw new Error("Expected the field `developer` to be a primitive type in the JSON string but got " + data['developer']);
        }
        // ensure the json data is a string
        if (data['profileImage'] && !(typeof data['profileImage'] === 'string' || data['profileImage'] instanceof String)) {
            throw new Error("Expected the field `profileImage` to be a primitive type in the JSON string but got " + data['profileImage']);
        }
        // ensure the json data is a string
        if (data['logoImage'] && !(typeof data['logoImage'] === 'string' || data['logoImage'] instanceof String)) {
            throw new Error("Expected the field `logoImage` to be a primitive type in the JSON string but got " + data['logoImage']);
        }
        // ensure the json data is a string
        if (data['appDesc'] && !(typeof data['appDesc'] === 'string' || data['appDesc'] instanceof String)) {
            throw new Error("Expected the field `appDesc` to be a primitive type in the JSON string but got " + data['appDesc']);
        }
        // ensure the json data is a string
        if (data['appUrl'] && !(typeof data['appUrl'] === 'string' || data['appUrl'] instanceof String)) {
            throw new Error("Expected the field `appUrl` to be a primitive type in the JSON string but got " + data['appUrl']);
        }
        if (data['campaigns']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['campaigns'])) {
                throw new Error("Expected the field `campaigns` to be an array in the JSON data but got " + data['campaigns']);
            }
            // validate the optional field `campaigns` (array)
            for (const item of data['campaigns']) {
                CampaignControllerDtoAppDetailAppDetailDataList.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
CampaignControllerDtoAppDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
CampaignControllerDtoAppDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
CampaignControllerDtoAppDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
CampaignControllerDtoAppDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
CampaignControllerDtoAppDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} appNo
 */
CampaignControllerDtoAppDetailResponse.prototype['appNo'] = undefined;

/**
 * @member {Number} category
 */
CampaignControllerDtoAppDetailResponse.prototype['category'] = undefined;

/**
 * @member {String} packageName
 */
CampaignControllerDtoAppDetailResponse.prototype['packageName'] = undefined;

/**
 * @member {String} title
 */
CampaignControllerDtoAppDetailResponse.prototype['title'] = undefined;

/**
 * @member {String} developer
 */
CampaignControllerDtoAppDetailResponse.prototype['developer'] = undefined;

/**
 * @member {String} profileImage
 */
CampaignControllerDtoAppDetailResponse.prototype['profileImage'] = undefined;

/**
 * @member {String} logoImage
 */
CampaignControllerDtoAppDetailResponse.prototype['logoImage'] = undefined;

/**
 * @member {String} appDesc
 */
CampaignControllerDtoAppDetailResponse.prototype['appDesc'] = undefined;

/**
 * @member {Number} distributionChannel
 */
CampaignControllerDtoAppDetailResponse.prototype['distributionChannel'] = undefined;

/**
 * @member {String} appUrl
 */
CampaignControllerDtoAppDetailResponse.prototype['appUrl'] = undefined;

/**
 * @member {Date} updateAt
 */
CampaignControllerDtoAppDetailResponse.prototype['updateAt'] = undefined;

/**
 * @member {Array.<module:model/CampaignControllerDtoAppDetailAppDetailDataList>} campaigns
 */
CampaignControllerDtoAppDetailResponse.prototype['campaigns'] = undefined;






export default CampaignControllerDtoAppDetailResponse;

